import clsx from "clsx";

import { Accordion } from "common/components/ui/Accordion";

import { NAVIGATOR_FILTER_CATEGORIES } from "../../../../../constants";
import Filter from "./Filter";

import type {
  NavigatorFilters,
  SelectedNavigatorFilters,
} from "../../../../../types";

export default function FiltersSelection({
  isSingleColumn,
  isLoading,
  returnedFilters,
  selectedFilters,
  setSelectedFilters,
}: {
  isSingleColumn: boolean;
  isLoading: boolean;
  returnedFilters: NavigatorFilters;
  selectedFilters: SelectedNavigatorFilters;
  setSelectedFilters: (selectedFilters: SelectedNavigatorFilters) => void;
}) {
  const filterCategoriesComponents = NAVIGATOR_FILTER_CATEGORIES.map(
    (category) => (
      <div className="flex flex-col gap-y-3" key={category.label}>
        <span className="text-button-sm text-black-500">{category.label}</span>
        <div className="flex flex-col overflow-hidden rounded-3xl border border-black-200 bg-whiteGray">
          {category.filters.map((filter) => (
            <Filter
              key={filter.label}
              returnedFilters={returnedFilters}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              filterData={filter}
              isLoading={isLoading}
            />
          ))}
        </div>
      </div>
    ),
  );
  return (
    <Accordion
      collapsible
      type="single"
      className={clsx("flex flex-1 gap-3", isSingleColumn && "flex-col")}
    >
      {isSingleColumn ? (
        filterCategoriesComponents
      ) : (
        <>
          <div className="flex flex-1 flex-col gap-y-3 overflow-hidden">
            {filterCategoriesComponents.slice(0, 3)}
          </div>
          <div className="flex flex-1 flex-col gap-y-3 overflow-hidden">
            {filterCategoriesComponents.slice(3)}
          </div>
        </>
      )}
    </Accordion>
  );
}
